import React  from 'react';
// import Clients from '../components/Clients';
import Cta from '../components/Cta';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import Intro from '../components/Intro';
// import Portfolio from '../components/Portfolio';
import Services from '../components/Services';
import { Link } from 'react-router-dom';

// Blog resimlerini import ediyoruz
import webTrendsImage from '../images/blog/web-trends-2024.png';
import mobileAppImage from '../images/blog/mobile-app-guide.png';
import ecommerceSeoImage from '../images/blog/ecommerce-seo.png';

const Home = () => {
    // Blog yazıları önizlemesi için
    const featuredPosts = [
        {
            id: 1,
            title: "Web Geliştirme Trendleri 2024",
            excerpt: "2024 yılında web geliştirme dünyasında öne çıkan trendleri ve teknolojileri keşfedin.",
            slug: "web-gelistirme-trendleri-2024",
            image: webTrendsImage,
            publishDate: "2024-01-15"
        },
        {
            id: 2,
            title: "Mobil Uygulama Geliştirme Rehberi",
            excerpt: "Başarılı mobil uygulama geliştirmek için bilmeniz gereken temel prensipler ve ipuçları.",
            slug: "mobil-uygulama-gelistirme-rehberi",
            image: mobileAppImage,
            publishDate: "2024-01-10"
        },
        {
            id: 3,
            title: "E-ticaret Sitesi Optimizasyonu",
            excerpt: "E-ticaret sitenizin performansını artırmak ve daha fazla satış yapmak için SEO stratejileri.",
            slug: "e-ticaret-sitesi-optimizasyonu",
            image: ecommerceSeoImage,
            publishDate: "2024-01-05"
        }
    ];

    return (
        <>
            <Hero />
            <Intro />
            <Services />
            {/* <Portfolio />
            <Clients /> */}
            <Cta/>
            {/* Blog Önizlemesi Bölümü */}
            <section className="py-20 bg-gray-50">
                <div className="container mx-auto px-4">
                    <div className="text-center mb-12" data-aos="fade-up">
                        <h2 className="text-4xl font-bold text-gray-900 mb-4">
                            Son Blog Yazılarımız
                        </h2>
                        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                            Teknoloji dünyasındaki son gelişmeler ve uzman görüşlerimiz
                        </p>
                    </div>
                    
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
                        {featuredPosts.map((post, index) => (
                            <article 
                                key={post.id}
                                className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300"
                                data-aos="fade-up"
                                data-aos-delay={index * 100}
                            >
                                <img 
                                    src={post.image} 
                                    alt={post.title}
                                    className="w-full h-48 object-cover"
                                />
                                
                                <div className="p-6">
                                    <div className="text-sm text-gray-500 mb-3">
                                        {post.publishDate}
                                    </div>
                                    
                                    <h3 className="text-xl font-bold text-gray-900 mb-3">
                                        <Link 
                                            to={`/blog/${post.slug}`}
                                            className="hover:text-cyan-500 transition-colors"
                                        >
                                            {post.title}
                                        </Link>
                                    </h3>
                                    
                                    <p className="text-gray-600 mb-4 line-clamp-3">
                                        {post.excerpt}
                                    </p>
                                    
                                    <Link 
                                        to={`/blog/${post.slug}`}
                                        className="inline-flex items-center text-cyan-500 hover:text-cyan-600 font-medium"
                                    >
                                        Devamını Oku
                                        <svg className="ml-1 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                        </svg>
                                    </Link>
                                </div>
                            </article>
                        ))}
                    </div>
                    
                    <div className="text-center mt-12" data-aos="fade-up">
                        <Link 
                            to="/blog"
                            className="inline-flex items-center px-6 py-3 bg-cyan-500 text-white font-medium rounded-lg hover:bg-cyan-600 transition-colors"
                        >
                            Tüm Blog Yazıları
                            <svg className="ml-2 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                            </svg>
                        </Link>
                    </div>
                </div>
            </section>
            <Footer />
        </>

    )
}

export default Home;

